module.exports = __webpack_public_path__ + "img/selected5-min.e5644658.png";